import { Component } from 'react';
import { connect } from 'react-redux';

import Slider from 'rc-slider';
import { RootState } from 'types';
import { checkDifferent } from 'utils/formHandlers';
import { translate } from 'utils/translate';

import ManualUpdateValue from './ManualUpdateValue';

interface RangeSliderProps {
    className?: string;

    name: string[];
    label: string;
    unit: string;

    value: number[];
    range: number[];
    decimal: number;
    onChange?: (name: string[], value: number[]) => void;

    language?: string;
    disabled?: boolean;
    isValid?: boolean;
}

interface RangeSliderState {
    language: string;
    value: number[];
    manualUpdate: boolean;
}

class RangeSlider extends Component<RangeSliderProps, RangeSliderState> {
    constructor(props: RangeSliderProps) {
        super(props);
        this.state = {
            language: 'en',
            value: [0, 0],
            manualUpdate: false,
        };
    }

    static getDerivedStateFromProps(props: RangeSliderProps, state: RangeSliderState) {
        if (props.language !== state.language || checkDifferent(props.value, state.value)) {
            return {
                language: props.language,
                value: props.value,
            };
        }
        return null;
    }

    componentDidMount(): void {
        this.setState({ value: this.props.value });
    }

    manualUpdateValue = () => {
        this.setState({ manualUpdate: !this.state.manualUpdate });
    };

    handleChange = (updatedValue: number[]) => {
        if (this.props.disabled || !this.props?.onChange) {
            return false;
        }
        const { name, onChange } = this.props;
        onChange?.(name, updatedValue);
    };

    handleManualChange = (updatedValue: number[]) => {
        if (this.props.disabled || !this.props?.onChange) {
            return false;
        }
        this.setState({ value: updatedValue }, () => {
            const { name, onChange } = this.props;
            onChange?.(name, updatedValue);
        });
    };

    render() {
        const { label, unit, range, decimal } = this.props;

        return (
            <div className="  mb-5 w-full no-select ">
                {this.state.manualUpdate ? (
                    <ManualUpdateValue
                        decimal={decimal}
                        unit={unit}
                        label={label}
                        close={this.manualUpdateValue}
                        value={this.state.value}
                        range={range}
                        save={this.handleManualChange}
                    ></ManualUpdateValue>
                ) : (
                    <>
                        <div className="block font-medium leading-5 text-gray-700   ">
                            <span className="capitalize">{label} </span>({unit}) : {translate('from')}
                            <span
                                onClick={this.manualUpdateValue}
                                className="cursor-pointer mx-1 underline  text-blue-700 lowercase  hover:text-blue-800 "
                            >
                                {this.state.value[0] !== range[0] ? this.state.value[0] : translate('min')}
                            </span>
                            {translate('to')}
                            <span
                                onClick={this.manualUpdateValue}
                                className="cursor-pointer mx-1 underline  text-blue-700 lowercase  hover:text-blue-800 "
                            >
                                {this.state.value[1] !== range[1] ? this.state.value[1] : translate('max')}
                            </span>
                        </div>
                        <Slider
                            className="mr-3 ml-1 w-auto"
                            range
                            step={Math.pow(10, -decimal)}
                            allowCross={false}
                            marks={this.state.value.reduce((acc, val) => {
                                acc[val] = <strong className="text-sm ">{val}</strong>;
                                return acc;
                            }, {})}
                            disabled={this.props.disabled}
                            min={range[0]}
                            max={range[1]}
                            value={this.state.value}
                            onChange={(updatedValue) => {
                                // @ts-ignore
                                this.handleChange(updatedValue);
                            }}
                            onChangeComplete={() => {
                                // @ts-ignore
                                this.handleChange(this.state.value);
                            }}
                        />
                    </>
                )}
            </div>
        );
    }
}

const rangeSliderStateToProps = (state: RootState) => ({
    language: state.user.language,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rangeSliderDispatchToProps = () => ({});

export default connect(rangeSliderStateToProps, rangeSliderDispatchToProps)(RangeSlider);
